import { FC } from 'react';
import { Typography, TypographyProps } from '@mui/material';
import Column, { ColumnProps } from '../Column';

interface EmptyCardContentProps extends ColumnProps {
    message?: string;
    height?: number | string;
    textProps?: TypographyProps;

    slotProps?: {
        typography?: TypographyProps;
    };
}

const EmptyCardContent: FC<EmptyCardContentProps> = ({
    children,
    message = 'No data available',
    slotProps = {},
    ...props
}) => {
    return (
        <Column alignItems="center" justifyContent="center" {...props}>
            {children ?? (
                <Typography variant="caption" color="text.secondary" {...slotProps?.typography}>
                    {message}
                </Typography>
            )}
        </Column>
    );
};

export default EmptyCardContent;
